import { createStore } from 'vuex'
import axios from 'axios';
import mergeDeep from '@/utils/merge';

import * as d3 from 'd3';

export default createStore({
	state: {
		data: [],
		gemeenteData: [],
		gemeentenList: [],
		autoComplete: [],
		currentStep: {},
		themes: [],
		showEndScreen: false,
		master: undefined
	},
	mutations: {
		SAVE_CONTENT (state, data) {
			state.data = data;
		}, 

		SAVE_DATA (state, data) {
			state.master = data;
			state.gemeentenList = data.gemeenten;
			state.autoComplete = data.gemeenten.map(d => { 
				return {label: d.gemeente_naam, value: d.gemeente_code}
			});


			state.aantal_in_categorie = {
				"Meer_dan_100000": 32,
				"Minder_dan_25000":	127,
				"Van_25000_tot_50000":	140,
				"Van_50000_tot_100000":	56
			}

		}, 

		SAVE_GEMEENTE_DETAIL(state, data) {
			let index = state.gemeentenList.findIndex(d => {return d.gemeente_code === data.gemeente_code});
			
			if(index) {
				let mergedObj = mergeDeep(state.gemeentenList[index], data)
				mergedObj.detail = true;
				state.gemeentenList[index] = mergedObj;
				state.gemeentenList[index].history = [];
			}
		},

		UPDATE_GEMEENTE(state, code) {
			let index = state.gemeentenList.findIndex(d => {return d.gemeente_code === code});

			state.selectedGemeenteIndex = index;
		},

		UPDATE_STEP(state, obj) {
			state.currentStep = obj;
		},

		ADD_THEMA(state, thema) {
			state.themes.push({title: thema, label: thema, thema: 'Thema'});
		},

		SHOW_END_SCREEN(state) {
			state.showEndScreen = true;
		},

		RESET_GEMEENTE(state) {
			state.selectedGemeenteIndex = undefined;
			state.themes = [];
		}

	},
	getters: {
		getMaster: state => state.master,
		showEndScreen: state => state.showEndScreen,
		currentStep: state => state.data.currentStep,
		landing: state => state.data.landing,
		autoComplete: state => state.autoComplete,
		selectedGemeente: state => state.selectedGemeenteIndex ? state.gemeentenList[state.selectedGemeenteIndex] : {},
		gemeentenList: state => state.gemeentenList,
		themes: state => state.themes,
		getThemaContent: (state) => (title) => {
			let index = state.data.themas.findIndex(t => t.Title === title)
			if(index === undefined) return;
			return state.data.themas[index];
		},
		getGemeenteById: (state) => (code) => {
			let index = state.gemeentenList.findIndex(d => {return d.gemeente_code === code});
			return state.gemeentenList[index]
		}		
	},
	actions: {
		loadContent ({ commit, state }) {
			return new Promise((resolve, reject) => { 
				axios
					.get(process.env.VUE_APP_API)
					.then(result => {
						commit("SAVE_CONTENT", result.data);
						resolve();
					})
					.catch(error => {
						reject();
						throw new Error(`API ${error}`);
					});
			})
		},

		loadData ({ commit, state }) {
			return new Promise((resolve, reject) => { 
				d3.json(process.env.VUE_APP_BASE + '/assets/master.json')
					.then(result => {
						commit("SAVE_DATA", result);
						resolve();
					})
					.catch(error => {
						reject();
						throw new Error(`API ${error}`);
					});
			})
		},

		loadGemeente ({ commit, state }, code) { 
			return new Promise((resolve, reject) => { 
				d3.json(process.env.VUE_APP_BASE + `/assets/gemeente/${code}.json`)
					.then(result => {
						commit("SAVE_GEMEENTE_DETAIL", result);
						resolve();
					})
					.catch(error => {
						reject();
						throw new Error(`API ${error}`);
					});
			})

		},

		showEndScreen({commit, state}) {
			commit("SHOW_END_SCREEN");
		},

		updateStep({commit, state}, obj) {
			commit("UPDATE_STEP", obj);
		},

		updateGemeente({commit, state}, gemeente) {
			commit("UPDATE_GEMEENTE", gemeente);
		},

		addThema({commit, state}, thema) {
			commit("ADD_THEMA", thema);
		},

		resetGemeente({commit, state}) {
			commit("RESET_GEMEENTE");
		}

	},
	modules: {

	}
})
